<template>
  <div ref="agreement" class="agreement">
    <!-- <h2 style="text-align: center">用户协议</h2> -->
    <div v-if="loading" style="text-align: center; padding: 40px">
      <van-loading size="30px" type="spinner" vertical>加载中..</van-loading>
    </div>
    <!-- 已同意协议点击查看已签署协议的内容 -->
    <div v-if="form.isAgreen" class="agreement-bd">
      <!-- 如果没有url 则说明没有截取到当时签协议的截图  则显示最新的协议内容并附上当时签署协议的时间与昵称 -->
      <!-- <img v-if="form.agreeUrl" :src="api.FileHost + form.agreeUrl" /> -->
    </div>
    <div
      v-if="form.AgreementId"
      id="agreement-bd"
      class="agreement-bd"
      style="padding-bottom: 60px"
    >
      <h1 style="font-size: 24px; text-align: center; margin: 16px 0">
        {{ form.Title }}
      </h1>
      <div style="text-align: right; padding: 0 0 10px 0">
        合同编号：____________
      </div>
      <div
        v-if="form.CompanyParty == 20"
        style="position: relative; line-height: 1.6"
      >
        <div>甲方：{{ partyA.username }}</div>
        <div v-if="AgreementInfo.EnableIdCard">身份证号：{{ partyA.id }}</div>
        <div v-if="AgreementInfo.EnableIdCard">
          联系方式：{{ partyA.phone }}
        </div>
        <van-button
          v-if="AgreementInfo.EnableIdCard && !partyA.id && !IsSalesConsultant"
          class="add-parta"
          size="small"
          style="display: none"
          type="primary"
          @click="showPartAAdd"
        >
          点击实名认证
        </van-button>
      </div>

      <div v-if="form.CompanyParty == 20" class="flex flex-wrap">
        <div>微信识别码：</div>
        <div class="flex-1"><img id="barcode" ref="barcode" /></div>
      </div>

      <div
        v-if="form.CompanyParty == 20"
        style="position: relative; margin: 16px 0 36px; line-height: 1.6"
      >
        <div>乙方：{{ tenant.TenantDesc }}</div>
        <div v-if="AgreementInfo.EnableIdCard && tenant.Address">
          注册地址：{{ tenant.Address }}
        </div>
        <div v-if="AgreementInfo.EnableIdCard && tenant.LegalPerson">
          法定代表人：{{ tenant.LegalPerson }}
        </div>
        <div v-if="AgreementInfo.EnableIdCard && tenant.Telephone">
          联系方式：{{ tenant.Telephone }}
        </div>
      </div>

      <div
        v-if="AgreementInfo.EnableIdCard && form.CompanyParty == 10"
        style="position: relative; line-height: 1.6"
      >
        <div>甲方：{{ tenant.TenantDesc }}</div>
        <div v-if="tenant.Address">注册地址：{{ tenant.Address }}</div>
        <div v-if="tenant.LegalPerson">
          法定代表人：{{ tenant.LegalPerson }}
        </div>
        <div v-if="tenant.Telephone">联系方式：{{ tenant.Telephone }}</div>
      </div>
      <div
        v-if="form.CompanyParty == 10"
        style="position: relative; line-height: 1.6; margin: 16px 0 0"
      >
        <div>乙方：{{ partyA.username }}</div>
        <div v-if="AgreementInfo.EnableIdCard">身份证号：{{ partyA.id }}</div>
        <div v-if="AgreementInfo.EnableIdCard">
          联系方式：{{ partyA.phone }}
        </div>
        <van-button
          v-if="AgreementInfo.EnableIdCard && !partyA.id && !IsSalesConsultant"
          class="add-parta"
          size="small"
          style="display: none"
          type="primary"
          @click="showPartAAdd"
        >
          点击实名认证
        </van-button>
      </div>
      <div v-if="form.CompanyParty == 10" class="flex flex-wrap">
        微信识别码：
        <img id="barcode" ref="barcode" />
      </div>

      <div class="ql-editor" v-html="form.content"></div>
      <table style="width: 100%; margin-top: 36px">
        <tr>
          <td style="width: 40px">甲方:</td>
          <td v-if="form.CompanyParty == 20">
            <div>{{ partyA.username }}</div>
            <!-- <div style="word-break: break-all; font-size: 14px">
              微信UnionId:{{ userInfo && userInfo.WechatUnionId }}
            </div> -->
          </td>
          <td v-if="form.CompanyParty == 10" style="min-width: 140px">
            <p style="text-align: left">
              {{ tenant && tenant.TenantDesc }}
            </p>
          </td>
          <td style="width: 40px">乙方:</td>
          <td v-if="form.CompanyParty == 20" style="min-width: 140px">
            <p style="text-align: left">
              {{ tenant && tenant.TenantDesc }}
            </p>
          </td>
          <td v-if="form.CompanyParty == 10">
            <div>{{ partyA.username }}</div>
            <!-- <div style="word-break: break-all; font-size: 14px">
              微信UnionId:{{ userInfo && userInfo.WechatUnionId }}
            </div> -->
          </td>
        </tr>
        <tr>
          <td v-if="form.CompanyParty == 10">
            <span v-if="AgreementInfo.EnableCorporateSeal">盖章:</span>
          </td>
          <td v-if="form.CompanyParty == 10" style="min-width: 140px">
            <img
              v-if="AgreementInfo.EnableCorporateSeal"
              class="Corporate-img"
              :src="api.FileHost + AgreementInfo.CorporateSealUrl"
              style="width: 140px; height: 140px"
            />
          </td>
          <td v-if="form.CompanyParty == 10">
            <span v-if="AgreementInfo.EnableAgreementSign">签名:</span>
          </td>
          <td v-if="form.CompanyParty == 10">
            <div
              v-if="AgreementInfo.EnableAgreementSign"
              style="
                height: 60px;
                line-height: 60px;
                position: relative;
                text-align: left;
              "
            >
              <a
                style="
                  padding: 0 0;
                  color: #1989fa;
                  display: block;
                  cursor: pointer;
                "
                @click="show = true"
              >
                <span v-if="AgreementInfo.Sign">
                  <img
                    id="img"
                    class="sign-img"
                    :src="AgreementInfo.Sign"
                    style="width: 150px; height: 60px"
                  />
                </span>
                <span v-else-if="!IsSalesConsultant">点击签名</span>
              </a>
            </div>
          </td>

          <td v-if="form.CompanyParty == 20">
            <span v-if="AgreementInfo.EnableAgreementSign">签名:</span>
          </td>
          <td v-if="form.CompanyParty == 20">
            <div
              v-if="AgreementInfo.EnableAgreementSign"
              style="
                height: 60px;
                line-height: 60px;
                position: relative;
                text-align: left;
              "
            >
              <a
                style="
                  padding: 0 0;
                  color: #1989fa;
                  display: block;
                  cursor: pointer;
                "
                @click="show = true"
              >
                <span v-if="AgreementInfo.Sign">
                  <img
                    id="img"
                    class="sign-img"
                    :src="AgreementInfo.Sign"
                    style="width: 150px; height: 60px"
                  />
                </span>
                <span v-else-if="!IsSalesConsultant">点击签名</span>
              </a>
            </div>
          </td>
          <td v-if="form.CompanyParty == 20">
            <span v-if="AgreementInfo.EnableCorporateSeal">盖章:</span>
          </td>
          <td v-if="form.CompanyParty == 20">
            <img
              v-if="AgreementInfo.EnableCorporateSeal"
              class="Corporate-img"
              :src="api.FileHost + AgreementInfo.CorporateSealUrl"
              style="width: 140px; height: 140px"
            />
          </td>
        </tr>
        <tr>
          <td></td>
          <td style="font-size: 14px">
            {{ time }}
          </td>
          <td></td>
          <td style="font-size: 14px">
            {{ time }}
          </td>
        </tr>
      </table>
    </div>
    <!-- <div
      v-if="!form.AgreementId && !loading"
      class="bd"
      style="text-align: center"
    >
      <h4>该产品暂未设置协议</h4>
    </div> -->
    <div
      v-if="form.AgreementId && !IsSalesConsultant"
      class="btn-box"
      style="display: none"
    >
      <van-checkbox v-model="form.agree" shape="square">
        我已阅读并同意协议
      </van-checkbox>
      <van-button
        block
        class="mt10"
        :disabled="!form.agree"
        size="large"
        type="primary"
        @click="submit"
      >
        同意协议
      </van-button>
    </div>
    <transition name="fade">
      <div v-if="show && height > 0" class="sign flex" style="display: none">
        <div class="btn-box2 flex flex-v flex-pack-center">
          <van-button
            class="sign-show"
            style="display: none"
            type="danger"
            @click="cancelSign"
          >
            取消
          </van-button>
          <van-button
            class="sign-show"
            style="display: none"
            type="default"
            @click="resetSign"
          >
            重写
          </van-button>
          <van-button
            class="sign-show"
            style="display: none"
            type="primary"
            @click="createSign"
          >
            确定
          </van-button>
        </div>
        <div class="sign-bd">
          <vue-esign
            ref="esign"
            v-model:bgColor="bgColor"
            class="sign-content"
            :height="height + 400"
            :is-crop="isCrop"
            :line-color="lineColor"
            :line-width="lineWidth"
            :width="width"
          />
        </div>
        <div class="sign-hd flex flex-v flex-pack-center flex-align-center">
          <div class="sign-show" style="display: none">请在空白处输入签名</div>
        </div>
      </div>
    </transition>
    <ReadFile ref="readFile" />
    <AddPartA ref="addPartA" :data="partyA" />
    <van-dialog
      v-model:show="dialogShow"
      cancel-button-color="#999"
      confirm-button-color="#000"
      confirm-button-text="去支付"
      show-cancel-button
      title="提示"
      :z-index="9999999"
      @confirm="dialogConfirm"
    >
      <div style="text-align: center; padding: 10px 0">
        您已签署协议,是否前往支付？
      </div>
    </van-dialog>
    <van-dialog
      v-model:show="authorShow"
      confirm-button-text="知道了"
      title="温馨提示"
    >
      <div class="author-content">
        <div class="author-title">您不是该协议的签署人员，请转发给</div>
        <div class="flex flex-wrap flex-align-center">
          <van-image
            v-if="authorObj.CustomerAvatar"
            class="author-img"
            height="24px"
            round
            :src="api.FileHost + authorObj.CustomerAvatar"
            width="24px"
          />
          <div class="author-name">{{ authorObj.CustomerName || '/' }}</div>
        </div>
        <div class="author-tip">
          注：若您就是{{ authorObj.CustomerName || '/' }}，请切换至相应微信
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script setup>
  /* eslint-disable */
  import JsBarcode from 'jsbarcode'
  import AddPartA from './components/AddPartA.vue'
  import { useRouter, useRoute } from 'vue-router'
  import ReadFile from '@/components/ReadFile'
  import { Notify, Toast, Dialog } from 'vant'
  import ZyUpload from '@/components/ZyUploader'
  import store from '@/store'
  import { ref, onMounted, unref, nextTick } from 'vue'
  import { wxShare, dataURItoBlobv2, uploadFile, img2Base64 } from '@/utils'
  import { addErrorLog } from '@/utils/errorLog'
  //import html2canvas from 'html2canvas'
  import html2canvas from '@/utils/html2canvas'
  import { dateFormat } from '@/utils/filters'
  import { getToken } from '@/utils/token'
  import '@/assets/scss/normalize.scss'
  import api from '@/api'
  import vueEsign from 'vue-esign'
  // import JsPDF from 'jspdf'

  const route = useRoute()
  const router = useRouter()
  const imgList = ref('')
  const tenant = ref({})
  const query = route.query
  const FormId = query.FormId
  const ProdId = query.ProdId
  const SkuId = query.SkuId
  const loading = ref(false)
  const imgUrl = ref('')
  const time = ref(dateFormat(new Date(), 'yyyy年MM月dd日'))
  const userInfo = ref(store.getters['user/getUserInfo'])
  const width = ref(0)
  const height = ref(0)
  const agreement = ref(null)
  const IsSalesConsultant = ref(true)

  const dialogShow = ref(false)
  const authorShow = ref(false)
  const authorObj = ref({
    CustomerAvatar: '',
    CustomerName: '',
  })
  const form = ref({
    CompanyParty: 20, //公司身份    10 甲方  ，20乙方
    content: '',
    agree: true,
    AgreementId: '',
    agreeUrl: '',
    isAgreen: false,
    Process: null,
    UserInfo: null,
    OrderNo: '', //code 为1005时且需要topay使用
    ToPay: false, //code 为1005时判断是否接下来需要去支付
  })

  let todo = null
  const show = ref(false) // 显示签名
  const lineWidth = ref(6)
  const lineColor = ref('#000000')
  const bgColor = ref('#fff')
  const resultImg = ref('')
  const isCrop = ref(false)
  const readFile = ref(null)
  const esign = ref(null)
  const AgreementInfo = ref({
    Sign: '',
    CorporateSealUrl: '',
    EnableCorporateSeal: false,
    EnableAgreementSign: false,
    EnableIdCard: false,
  })

  /**
   * 弹出实名认证
   * @author hanson.liu
   * @date 2022-08-09
   * @returns {any}
   */
  const addPartA = ref(null)
  const partyA = ref({
    username: '',
    id: '',
    phone: '',
  })
  const showPartAAdd = () => {
    console.log(addPartA.value)
    addPartA.value.show()
  }
  const dialogConfirm = async () => {
    const h5url = await store.getters['system/getH5Url']
    const token = getToken()
    const url = `${h5url}home/#/pagesPay/settlement/sales?type=sales&orderNo=${
      form.value.OrderNo || ''
    }&token=${token}`
    window.location.href = url
  }

  const getAgreenment = () => {
    loading.value = true
    wxShare('用户协议', '请认真阅读并同意协议')
    return store
      .dispatch('survey/ProductAgreementGet', {
        ProdId,
        FormId,
        SkuId,
      })
      .then(async (data) => {
        await GetAgreementInfo()
        loading.value = false
        if (data.Code === 0) {
          //Authorized==false，则表示当前用户不是此销售线索的客户，也不是销售顾问，需要弹出如下信息：
          if (!data.Data.Authorized) {
            authorObj.value.CustomerAvatar = data.Data.CustomerAvatar
            authorObj.value.CustomerName = data.Data.CustomerName
            authorShow.value = true
            return false
          }

          form.value.CompanyParty = data.Data.CompanyParty || 20
          form.value.AgreementId = data.Data.AgreementId
          form.value.content = data.Data.Content
          form.value.Title = data.Data.Title
          IsSalesConsultant.value = data.Data.IsSalesConsultant
          if (IsSalesConsultant.value) {
            Dialog.alert({
              title: '提示',
              message: `检查无误后，请转发协议给【${
                data.Data.CustomerName || '/'
              }】签署`,
              confirmButtonText: '知道了',
            })
          }
        }
      })
      .catch(async (e) => {
        const { Code } = e
        let msg = e.Message
        if (Code === 1005) {
          form.value.isAgreen = true
          form.value.agreeUrl = e.Message
          form.value.ToPay = e.Data && e.Data.ToPay
          form.value.OrderNo = (e.Data && e.Data.OrderNo) || ''
          msg = '您已签署过协议！'
          return
        }
        if (Code === 1004) {
          await GetAgreementInfo()
          form.value.isAgreen = true
          const Data = JSON.parse(e.Message)
          form.value.content = Data.Agreement.Content
          form.value.Process = Data.Process
          form.value.UserInfo = Data.UserInfo

          msg = '您已签署过协议！'
          return
        }
        Dialog.alert({
          title: '温馨提示',
          message: msg || '出错了，请稍后再试',
          confirmButtonText: '知道了',
        }).then(() => {})
        loading.value = false
      })
  }
  onMounted(async () => {
    // const h5url = await store.getters['system/getH5Url']
    // const url = `${h5url}`
    // console.log('h5url', h5url)
    await getAgreenment()
    width.value = document.body.offsetWidth
    height.value = document.body.offsetHeight
    init()
    const jsbarcode = document.getElementById('barcode')
    if (jsbarcode) {
      JsBarcode('#barcode', userInfo.value.WechatUnionId, {
        width: 1,
        height: 50,
        fontSize: 12,
        margin: 3,
        valid: (data) => {
          console.log(data)
        },
      })
    }
  })

  const init = async () => {
    tenant.value = await store.getters['user/getTenant']
    const h5url = await store.getters['system/getH5Url']
    const token = getToken()
    if (form.value.isAgreen && form.value.agreeUrl) {
      readFile.value.readFile({
        MaterialName: '已签署的协议',
        MaterialUrl: form.value.agreeUrl,
      })

      if (form.value.ToPay) {
        setTimeout(() => {
          dialogShow.value = true
        }, 500)
      }
    }
    // 所有图片转base64 要不转换的pdf可能会看不了那张图片
    const imgList = Array.from(document.getElementsByTagName('img'))
    imgList.forEach(async (item) => {
      const base64 = await img2Base64(item)
      item.src = base64
    })
  }

  // 清空签名
  const resetSign = () => {
    esign.value.reset()
  }

  const cancelSign = () => {
    show.value = false
    todo = null
  }

  const createSign = () => {
    esign.value
      .generate()
      .then(async (res) => {
        const newImg = await drawImgToCanvas(res, -90)
        AgreementInfo.value.Sign = newImg
        show.value = false
        if (todo) {
          nextTick(() => {
            todo()
          })
        }
      })
      .catch((err) => {
        Toast('请输入签名')
      })
  }

  const drawImgToCanvas = (image, rotate) => {
    return new Promise((resolve, reject) => {
      var canvas = document.createElement('canvas')
      var context = canvas.getContext('2d')
      var img = new Image()
      img.setAttribute('crossOrigin', 'Anonymous')
      img.src = image

      img.onload = function () {
        canvas.width = img.height
        canvas.height = img.width

        context.translate(canvas.width / 2, canvas.height / 2)
        context.rotate((rotate * Math.PI) / 180)
        context.translate(-canvas.width / 2, -canvas.height / 2)
        context.drawImage(
          img,
          canvas.width / 2 - img.width / 2,
          canvas.height / 2 - img.height / 2
        )
        context.translate(canvas.width / 2, canvas.height / 2)
        context.rotate((-rotate * Math.PI) / 180)
        context.translate(-canvas.width / 2, -canvas.height / 2)
        context.restore()
        var base64 = canvas.toDataURL('image/png', 0.9)
        //testImg.src = base64
        resolve(base64)
        //console.log('base64', base64)
      }
    })
  }

  // 获取是否需要手写签名
  const GetAgreementInfo = async () => {
    const tenant = await store.getters['user/getTenant']
    return store
      .dispatch('system/GetAgreementInfo', {
        tenantId: tenant.TenantId,
      })
      .then((data) => {
        const { Data } = data
        Object.assign(AgreementInfo.value, Data)
      })
  }

  const gethtml = async () => {
    //window.document.head.innerHTML,
    let html = `<!DOCTYPE html>
      <html>
      <head>
      <style>
      .ql-editor{line-height:1.42;}
      .ql-editor .ql-size-small{font-size:0.75em}
      .ql-editor .ql-size-large{font-size:1.5em}
      .ql-editor .ql-size-huge{font-size:2.5em}
      .ql-editor .ql-direction-rtl{direction:rtl;text-align:inherit}
      .ql-editor .ql-align-center{text-align:center}
      .ql-editor .ql-align-justify{text-align:justify}
      .ql-editor .ql-align-right{text-align:right}
      .ql-snow a {color: #06c;}
      </style>
      </head>
      <body>
      ${window.document.body.innerHTML}
      </body>
      </html>`

    // fs.readFile('@/assets/scss/normalize.scss', 'utf-8', function (err, data) {
    //   if (err) {
    //     console.log(err)
    //   } else {
    //     console.log(data)
    //   }
    // })

    //let html = temp.join('')
    const h5url = await store.getters['system/getH5Url']
    html = html.replace(/<link href="css/g, `<link href="${h5url}survey/css`)
    html = html.replace(/请先阅读并同意协议/g, ``)
    html = html.replace(/请先阅读协议并签名/g, ``)
    return html
  }

  const submit = async () => {
    if (FormId) {
      // console.log('lalal', AgreementInfo.value.EnableIdCard)
      if (AgreementInfo.value.EnableIdCard) {
        if (!partyA.value.id) {
          Toast('请先进行实名认证')
          return
        }
      }
      if (!form.value.agree) {
        Toast('请先阅读并同意协议')
        return
      }
      if (
        AgreementInfo.value.EnableAgreementSign &&
        !AgreementInfo.value.Sign
      ) {
        Toast('请先阅读协议并签名')
        todo = submit
        show.value = true
        return
      }
      todo = null
      const toast = Toast.loading({
        message: '正在提交...',
        forbidClick: false,
        duration: 0,
        loadingType: 'spinner',
      })

      agree()
    }
  }

  const agree = (msg = '') => {
    const barcode = document.getElementById('barcode').src
    const params = {
      Pass: true,
      Remark: '用户同意了协议' + msg,
      Screenshot: imgList.value,
      Recording: '',
      FormId: FormId,
      SkuId,
      AgreementId: form.value.AgreementId,
      //AgreementAttachUrl: html,
      //HtmlContent: html,
      username: partyA.value.username,
      identityNumber: partyA.value.id,
      phone: partyA.value.phone,
      signature: AgreementInfo.value.Sign,
      wxUnionIdBarCode: barcode,
    }

    return store
      .dispatch('survey/WorkflowAgreement', params)
      .then((data) => {
        const { Code, Message, Data } = data
        if (Code === 0) {
          Toast.success('提交成功！')
          setTimeout(async () => {
            Toast.clear()
            if (Data && Data.ToPay) {
              // 跳转到付款
              // console.log('进来了')
              const h5url = await store.getters['system/getH5Url']
              const token = getToken()
              const url = `${h5url}home/#/pagesPay/settlement/sales?type=sales&orderNo=${
                Data.OrderNo || ''
              }&token=${token}`
              window.location.href = url
            } else {
              router.push({ path: '/survey/answerComplete' })
            }
          }, 2000)
        } else {
          let msg = Message || '提交失败'
          Toast(msg)
          addErrorLog({ message: '协议失败：' + msg }, null, 'info')
        }
      })
      .catch((e) => {
        let msg = e.Message || '提交失败'
        if (e.Code === 7005) {
          msg = '用户协议需本人签署'
        }
        Toast.fail(msg)
        setTimeout(() => {
          Toast.clear()
        }, 3000)
      })
  }
</script>
<style lang="scss" scoped>
  .agreement {
    padding: 10px 12px 40px;
    .ql-editor {
      padding: 0 !important;
    }
    .Corporate-img {
    }
    .sign-btn {
      // padding: 2px 5px;
      // color: #1989fa;
    }
    .sign-img {
      // width: 50px;
      // display: block;
      // transform: rotate(-90deg);
      // transform-origin: 30% 30%;
    }
    // .canvas-img {
    //   background-color: #ffff00;
    //   width: 50%;
    //   height: 200%;
    //   transform: rotate(-90deg);
    //   transform-origin: 30px 30px;
    // }
  }
  .btn-box {
    display: block !important;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 12px 16px;
    background: #fff;
  }
  .mt10 {
    margin-top: 12px;
  }
  .sign {
    display: flex !important;
    position: fixed;
    background: #fff;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    .sign-hd {
      background: #f0f0f0;
      width: 50px;
      line-height: 1;
      > div {
        width: 160px;
        transform: rotate(90deg);
      }
    }
    .btn-box2 {
      width: 70px;
      height: 100%;
      background: #f0f0f0;
      button {
        transform: rotate(90deg);
        padding: 0;
        width: 100px;
        margin: 50px -15px;
      }
    }
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: all 0.3s ease;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0; /*透明度*/
    transform: translateX(-50%);
  }
  .sign-show {
    display: block !important;
  }
  .sign-content {
    display: block !important;
    height: 100%;
  }
  .add-parta {
    display: block !important;
    position: absolute;
    top: 50%;
    margin-top: -18px;
    left: 100px;
  }
  .author-title {
    // text-align: center;
    font-size: 13px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.65);
    line-height: 24px;
    margin-top: 10px;
  }
  .author-img {
    // margin-top: 5px;
  }
  .author-name {
    height: 24px;
    font-size: 13px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    line-height: 24px;
    margin-left: 5px;
  }
  .author-tip {
    font-size: 12px;
    font-weight: 400;
    color: #d48806;
    line-height: 17px;
    margin: 14px 0;
  }
  .author-content {
    padding-left: 40px;
    box-sizing: border-box;
  }
  ::v-deep {
    li {
      // list-style: auto !important;
      // &::before {
      //   content: '' !important;
      //   display: none !important;
      // }
    }
    // ul {
    //   padding-left: 0px !important;
    // }
    // ul > li {
    //   padding-left: 0px !important;
    // }
  }
</style>
